import React, { useState } from 'react';
import { formatRupiah, sendAnalyticsEvent, checkTime, checkHoldTime } from '../../../utils/helper';
import star from '../../../common/images/revamp/icon/star.svg';
import motorbike from '../../../common/images/revamp/icon/motorbike.svg';
import tagPrice from '../../../common/images/revamp/icon/tag-purple.svg';
import discount from '../../../common/images/revamp/icon/discount.svg';
import { twMerge } from 'tailwind-merge';
import useSearchList from './useSearchList';
import SearchProduct from './Product';
import FoodImg from '../../../common/images/food.png'
import { ChevronRightIcon, ClockIcon } from '@heroicons/react/24/solid';
import { LoaderIcon, PinPointIcon } from '../../../utils/svg';
import { useDispatch, useSelector } from 'react-redux';
import NoOutlet from '../../Outlet/NoOutlet';
import { resetOutletByLocation, setOpenOtherLocation } from '../../../store/reducers/outlet';
import OutletByLocation from '../../Outlet/Location';
import useNavigation from '../../../hook/useNavigation';

const SearchList = (props) => {
	const { outlets } = props;

	const { handleTotalPrice, handleTotalQuantity } = useSearchList();
  const dispatch = useDispatch();
  const navigate = useNavigation();

  const isLoadingOtherLocation = useSelector((state) => state.outlet?.isLoadingOtherLocation || false);
	const selectedStoreID = useSelector((state) => state.outlet?.selectedStoreID || null);
  const [selectedBrandID, setSelectedBrandID] = useState(null);
	const [openOtherLocation, setOpenOtherLocationState] = useState(false);
  const latitude = useSelector((state) => state.user?.latitude);
	const longitude = useSelector((state) => state.user?.longitude);
  const isOpenOtherLocation = useSelector((state) => state.outlet?.isOpenOtherLocation || false);



  const handleOutletByLocationClick = async (item = null) => {
    console.log('handleOutletByLocationClick');
		setSelectedBrandID(item ?? null);
		setOpenOtherLocationState(true);
	};

  const handleOutletByLocationCloseClick = async () => {
		dispatch(resetOutletByLocation());
		setSelectedBrandID(null);
		setOpenOtherLocationState(false);
	};

	return (
		<div>
			<div className={twMerge('py-3 flex flex-col gap-[26px] pb-28')}>
				{outlets?.map((item, index) => {
					const distance = parseFloat(item?.distance || 0)?.toFixed('2');
					const isBusy = item?.endHold && checkHoldTime(item?.endHold);
					const outletStatus = isBusy
						? `Resto sedang sibuk`
						: `Tutup${item?.outletOpenTime
							? ` - Buka pukul ${item?.outletOpenTime} ${checkTime(item?.outletOpenTime)} hari ini`
							: ""}`;
					return (
						<div key={index} className='space-y-4'>
							<div
								id='search_food_select_outlet'
								className='px-4 flex justify-between gap-3'
								onClick={() => {
									if (item?.outOfDelivery) return;
									if (item?.storeOpen === '1') {
										sendAnalyticsEvent('Click Outlet', 'search_food_select_outlet', item?.storeSlug)
										navigate.push(`/outlet/${item?.storeSlug}/delivery`)
									}
								}}>
								<img src={item?.storeImage || FoodImg} alt='outlet-img' className='rounded-lg w-24 h-24 object-cover aspect-square' />
								<div className='grow space-y-1'>
									<div className={`${item?.storeOpen === '0' ? 'flex' : 'hidden'} items-center`}>
										<ClockIcon class='h-4 w-4 text-red-500 mr-1' />
										<div className='text-xs font-normal text-gray-900'>{outletStatus}</div>
									</div>
									<div className={`${item?.outOfDelivery && item?.storeOpen === '1' ? 'flex' : 'hidden'} items-center`}>
										<PinPointIcon className={'stroke-red-500 text-red-500 fill-red-500 mr-1'} />
										<div className='text-xs font-normal text-orange-700'>Diluar Jangkauan Pengiriman</div>
									</div>
									<p className={`mb-0 !mt-0 font-semibold text-sm cursor-pointer ${item?.storeOpen === '0' || item?.outOfDelivery ? 'text-gray-400' : 'text-[var(--dark-gray)]'} line-clamp-1 max-w-[calc(100vw-139px)]`}>
										{item?.storeName}
									</p>
									<div className='flex gap-3 items-center !mt-0'>
										{item?.rating && (
											<div className='flex items-center gap-1'>
												<img src={star} alt='star' />
												<span className='font-medium text-xxs text-[var(--dark-gray)]'>
													{item?.rating || 0} ({item?.totalRating || 0})
												</span>
											</div>
										)}
										<div className='flex items-center gap-1'>
											<img src={motorbike} alt='motorbike' />
											<span className='text-xxs'>{distance} km</span>
										</div>
									</div>
									{item?.offerInfo && (
										<div className='flex items-center gap-1'>
											<img src={tagPrice} alt='tagPrice' />
											<span className='font-medium text-xs text-[var(--dark-gray)]'>{item?.offerInfo}</span>
										</div>
									)}
                  <div
                    id='homepage_see_other_outlets'
                    className='inline-flex gap-2 items-center py-1.5 px-2.5 !bg-[var(--rose-violet-opacity)] text-[var(--rose-violet)] rounded-full mt-0.5 cursor-pointer min-w-40 justify-between text-xs'
                    onClick={(event) => {
                      event.stopPropagation();
                      handleOutletByLocationClick(item)
                    }}>
                    <div className='w-full flex justify-center'>{isLoadingOtherLocation && selectedStoreID === item?.storeID ? <LoaderIcon /> : 'Cek lokasi lainnya'}</div>
                    <ChevronRightIcon className='text-[var(--rose-violet)] w-5 h-5' />
                  </div>
								</div>
							</div>
							{item?.products?.length > 0 && <SearchProduct products={item?.products} storeSlug={item?.storeSlug} storeOpen={item?.storeOpen} outOfDelivery={item?.outOfDelivery} />}
						</div>
					)
				})}
			</div>
			{handleTotalQuantity() > 0 && (
				<div className='fixed bottom-0 shadow-custom w-full p-4 bg-white z-20'>
					<div className='flex space-x-1.5 items-center mb-2'>
						<img src={discount} alt='discount' />
						<span className='text-[var(--dark-gray)] text-xs'>Yay, you're saving 10k. Add more and save up to 50k!</span>
					</div>
					<button className='bg-[var(--rose-violet)] w-full text-white py-3 px-4 font-semibold flex justify-between gap-2'>
						<div>{handleTotalQuantity()} item in cart</div>
						<div>{formatRupiah(handleTotalPrice())}</div>
					</button>
				</div>
			)}
			{openOtherLocation && selectedBrandID?.brandID ? (
				<OutletByLocation
					isOpen={openOtherLocation}
					onClose={() => handleOutletByLocationCloseClick()}
					latitude={latitude}
					longitude={longitude}
					outletSelected={selectedBrandID}
				/>
			) : !isLoadingOtherLocation && openOtherLocation ? (
				<NoOutlet isOpen={isOpenOtherLocation} onClose={() => dispatch(setOpenOtherLocation(false))} />
			) : null}
		</div>
	);
};

export default SearchList;
